import { __rest } from "tslib";
import url from 'url';
import { NAVIGATION_STATE_PARAM_NAME, SELECTED_NODE_ID, LOCALE_CODE_REGEX, b2cSiteTypeURLPrefix, siteType, OFFSET_PARAM_NAME, PRODUCTS_PER_PAGE_PARAM_NAME, EQdsButtonImportance, EQdsButtonSize, PesLinkEnum, join, format, setNonceToElement, } from '@pes-ui/utils';
import isUndefined from 'lodash/isUndefined';
import nth from 'lodash/nth';
import { parse } from 'querystring';
import { listingTypes, pageParam } from '../../components/category-subcategory-listing/constants';
export const isDefined = (value) => {
  return !isUndefined(value);
};
export const getArray = (value) => {
  if (isUndefined(value)) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
};
export const raf = (handler) => {
  if (typeof requestAnimationFrame === 'function') {
    return requestAnimationFrame(handler);
  }
  return setTimeout(handler);
};
export const componentOnReady = (el, callback) => {
  if (el.componentOnReady) {
    el.componentOnReady().then(callback);
  }
  else {
    raf(callback);
  }
};
export const asyncComponentOnReady = (element) => {
  return new Promise((resolve) => componentOnReady(element, resolve));
};
export const html2plain = (html) => {
  const tempEl = document.createElement('div');
  tempEl.innerHTML = html;
  return tempEl.textContent || tempEl.innerText || '';
};
const getOffsetTop = (el) => {
  let offsetTop = 0;
  let currentElement = el;
  while (currentElement.offsetParent) {
    offsetTop += currentElement.offsetTop;
    currentElement = currentElement.offsetParent;
  }
  return offsetTop;
};
export const scrollToTop = (el) => {
  var _a, _b;
  const headerHeight = (_b = (_a = document.querySelector('header')) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height) !== null && _b !== void 0 ? _b : 0;
  window.scrollTo({
    top: getOffsetTop(el) - headerHeight,
    behavior: 'smooth',
  });
};
export const createNewScripts = (scripts) => {
  const newScripts = [];
  scripts.forEach((script) => {
    const newScript = document.createElement('script');
    Array.from(script.attributes).forEach((attr) => {
      if (attr.nodeValue) {
        newScript.setAttribute(attr.nodeName, attr.nodeValue);
      }
    });
    setNonceToElement(newScript);
    newScripts.push(newScript);
    script.remove();
  });
  return newScripts;
};
export const pasteScripts = (element, selector, parameters = {}) => {
  const { shadow = false } = parameters;
  let content;
  if (shadow) {
    content = element.shadowRoot.querySelector(selector);
  }
  else {
    content = element.querySelector(selector);
  }
  if (content) {
    const scripts = content.querySelectorAll('script');
    const newScripts = createNewScripts(scripts);
    newScripts.forEach((child) => {
      content.appendChild(child);
    });
  }
};
export const getLocaleCodes = (localeCode) => {
  if (!localeCode)
    return null;
  const HOST_REGEX = /^https?:\/\/[^\/]+/;
  const input = localeCode.replace(HOST_REGEX, '');
  const matchArray = input === null || input === void 0 ? void 0 : input.match(LOCALE_CODE_REGEX);
  if (!matchArray) {
    return null;
  }
  const countryCode = matchArray[matchArray.length - 2];
  const languageCode = matchArray[matchArray.length - 1];
  return {
    countryCode: countryCode === null || countryCode === void 0 ? void 0 : countryCode.toLowerCase(),
    languageCode: languageCode === null || languageCode === void 0 ? void 0 : languageCode.toLowerCase(),
  };
};
export const getQueryParam = (paramName, defaultValue = '') => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.has(paramName) ? searchParams.get(paramName) : defaultValue;
};
export const getCountry = (localeCode) => { var _a; return (_a = nth(localeCode.split('/'), -2)) !== null && _a !== void 0 ? _a : ''; };
export const isApc = (localeCode) => nth(localeCode.split('/'), -3);
export const getContextRoot = (localeCode) => nth(localeCode.split('/'), -3);
export const getLanguage = (localeCode) => { var _a; return (_a = nth(localeCode.split('/'), -1)) !== null && _a !== void 0 ? _a : ''; };
export const getLocale = (countryCode, languageCode) => join('/', countryCode, languageCode);
export const replacePlusWithSpace = (s) => s.replace(/\+/g, ' ');
export const getNavigationState = (rawNavState) => {
  var _a;
  const navStateWithSpace = replacePlusWithSpace(rawNavState);
  const urlSearchParams = new URLSearchParams(navStateWithSpace);
  return navStateWithSpace.replace(/\+/g, ' ').search(/\=/) === -1
    ? navStateWithSpace
    : (_a = urlSearchParams.get(NAVIGATION_STATE_PARAM_NAME)) !== null && _a !== void 0 ? _a : urlSearchParams.get(NAVIGATION_STATE_PARAM_NAME.toLowerCase());
};
export const getProductsUrl = (pathname, navState, offset, productsPerPage, filter) => {
  if (navState === '?') {
    return url.format({
      pathname,
      query: {
        No: offset,
        Nrpp: productsPerPage,
        format: 'json',
        filter,
      },
    });
  }
  return url.format({
    pathname,
    query: Object.assign(Object.assign({}, (navState.includes('subNodeId')
      ? { subNodeId: navState.replace('?subNodeId=', '') }
      : { N: getNavigationState(navState) })), { No: offset, Nrpp: productsPerPage, format: 'json', filter }),
  });
};
export const openPopupCenter = ({ url, title, w = 1015, h = 680 }) => {
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : window.screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : window.screen.height;
  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft;
  const top = (height - h) / 2 / systemZoom + dualScreenTop;
  const newWindow = window.open(url, title, `
      scrollbars=yes,
      width=${w / systemZoom},
      height=${h / systemZoom},
      top=${top},
      left=${left}
      `);
  if (window.focus)
    newWindow.focus();
};
export const getSiteTypeByURL = (location) => {
  return document.location.href.startsWith(`${location}/${b2cSiteTypeURLPrefix}`)
    ? siteType.B2C
    : siteType.B2B;
};
export const calcBundlePrice = (countryLanguageCode, productActivePrice, productActivePriceValue, bundleActivePriceValue, qty) => {
  if (!productActivePrice || !productActivePriceValue || !bundleActivePriceValue) {
    return null;
  }
  const currencyCode = productActivePrice.match(/\D$|^\D/);
  const finalPrice = (productActivePriceValue + bundleActivePriceValue * qty).toFixed(2);
  const formattedPrice = format(finalPrice, { locale: countryLanguageCode });
  if (currencyCode.index === 0) {
    return `${currencyCode}${formattedPrice}`;
  }
  return `${formattedPrice}${currencyCode}`;
};
export const addParameterToLink = function (link, queryParams, hash) {
  if (!link)
    return '';
  const urlParsed = url.parse(link, true);
  const formatedQueryParams = Object.keys(queryParams).reduce((acc, key) => {
    const queryParam = queryParams[key];
    if (queryParam) {
      let parsedQueryParam;
      if (typeof queryParam === 'string' && queryParam.search('=') !== -1) {
        parsedQueryParam = parse(queryParam);
      }
      else {
        parsedQueryParam = { [key]: queryParam };
      }
      return Object.assign(Object.assign({}, acc), parsedQueryParam);
    }
    return acc;
  }, {});
  const { query } = urlParsed, rest = __rest(urlParsed, ["query"]);
  return url.format(Object.assign(Object.assign({ query: Object.assign(Object.assign({}, query), formatedQueryParams) }, rest), { hash: hash || urlParsed.hash }));
};
export const getBrandName = () => {
  if (window.isApc)
    return 'apc';
  if (window.isAsco)
    return 'ascopower';
  if (window.customBrand)
    return window.customBrand;
  return 'se';
};
export const getLocaleWithV3 = (locale, isPublic) => {
  if (isPublic)
    return locale;
  return `${locale}/v3`;
};
export const filterQueryParams = () => {
  const filter = getQueryParam('filter') || '';
  if (filter !== '')
    return `&filter=${filter}`;
  return '';
};
export const getSprykerBaseQueryParams = (host) => {
  const countryCode = getCountry(host);
  const languageCode = getLanguage(host);
  const contextRoot = getContextRoot(host);
  return { countryCode, languageCode, contextRoot };
};
export const getSprykerBaseQueryParamString = (host) => {
  return `brand=${getBrandName()}&country-code=${getCountry(host)}&language-code=${getLanguage(host)}`;
};
export const getCategoryOrSubCatFilterUrl = (baseFilterUriPath, localeCode, subCategoryListingParams, filter) => {
  const sprykerBaseQueryParamString = getSprykerBaseQueryParamString(localeCode);
  const searchParams = new URLSearchParams(window.location.search);
  const subCategoryListingQueryParams = subCategoryListingParams.pageParam
    === listingTypes.SUBCATEGORY_LISTING
    ? `&subcategory-id=${subCategoryListingParams.subCategoryId}&pageParam=${pageParam.SUBCATEGORY_LISTING}`
    : '';
  if (searchParams.has(NAVIGATION_STATE_PARAM_NAME))
    return `${baseFilterUriPath}?${searchParams.get(NAVIGATION_STATE_PARAM_NAME)}`;
  return `${baseFilterUriPath}?${sprykerBaseQueryParamString}${subCategoryListingQueryParams}&filter=${filter}`;
};
export const filterReset = (CurrentCheckedUrl, baseFilterUrl) => {
  return CurrentCheckedUrl === baseFilterUrl;
};
export const getBaseUrl = (baseUriPath, localeCode) => {
  const filter = getQueryParam('filter') || '';
  return filter !== ''
    ? `${baseUriPath}?${getSprykerBaseQueryParamString(localeCode)}&filter=${filter}`
    : `${baseUriPath}?${getSprykerBaseQueryParamString(localeCode)}`;
};
export const getCategoryRangesFilterUrl = (baseRangesUriPath, localeCode, subCategoryListingParams) => {
  const sprykerBaseQueryParamString = getSprykerBaseQueryParamString(localeCode);
  const searchParams = new URLSearchParams(window.location.search);
  const subCategoryListingQueryParams = subCategoryListingParams.pageParam
    === listingTypes.SUBCATEGORY_LISTING
    ? `&subcategory-id=${subCategoryListingParams.subCategoryId}`
    : '';
  if (searchParams.has(NAVIGATION_STATE_PARAM_NAME))
    return `${baseRangesUriPath}?${searchParams.get(NAVIGATION_STATE_PARAM_NAME)}`;
  return `${baseRangesUriPath}?${sprykerBaseQueryParamString}${subCategoryListingQueryParams}${filterQueryParams()}`;
};
export const getNavigationUrl = (queryParamString, keysToRetain) => {
  const params = new URLSearchParams(queryParamString);
  const SrykerfilterQueryParams = Object.fromEntries(params);
  Object.keys(SrykerfilterQueryParams).forEach((key) => {
    if (!keysToRetain.includes(key)) {
      delete SrykerfilterQueryParams[key];
    }
  });
  return queryParamString.substring(new URLSearchParams(SrykerfilterQueryParams).toString().length + 1);
};
export function navigationPush(searchParams, path = '') {
  if (searchParams.toString() !== '') {
    window.history.pushState({}, '', `${path}?${searchParams.toString()}${window.location.hash}`);
  }
  else {
    window.history.pushState({}, '', window.location.href.split('?')[0]);
  }
}
export const getRangeFilterUrl = (filterNodeId, filtersUriPath, localeCode) => {
  const searchParams = new URLSearchParams(window.location.search);
  const sprykerBaseQueryParamString = getSprykerBaseQueryParamString(localeCode);
  if (filterNodeId && !searchParams.has(NAVIGATION_STATE_PARAM_NAME)) {
    return `${filtersUriPath}?${sprykerBaseQueryParamString}&hlnode-id=${filterNodeId}`;
  }
  return searchParams.has(NAVIGATION_STATE_PARAM_NAME)
    ? `${filtersUriPath}?${searchParams.get(NAVIGATION_STATE_PARAM_NAME)}`
    : `${filtersUriPath}?${sprykerBaseQueryParamString}`;
};
export function getPaginationParams(defaults) {
  const offset = Number(getQueryParam(OFFSET_PARAM_NAME, defaults.offset.toString()));
  const productsPerPage = Number(getQueryParam(PRODUCTS_PER_PAGE_PARAM_NAME, defaults.productsPerPage.toString()));
  return { offset, productsPerPage };
}
export const getFilterProductsUrl = (baseProductsUriPath, numberOfProducts, localeCode, filterNodeId, subCategoryListingParams) => {
  const sprykerBaseQueryParamString = getSprykerBaseQueryParamString(localeCode);
  const subcategoryListingProductParms = subCategoryListingParams.pageParam
    === listingTypes.SUBCATEGORY_LISTING
    ? `&subcategory-id=${subCategoryListingParams.subCategoryId}`
    : '';
  const { offset, productsPerPage } = getPaginationParams({
    offset: 0,
    productsPerPage: Number(numberOfProducts),
  });
  const searchParams = new URLSearchParams(window.location.search);
  if (filterNodeId && !searchParams.get(NAVIGATION_STATE_PARAM_NAME)) {
    return `${baseProductsUriPath}?${sprykerBaseQueryParamString}&hlnode-id=${filterNodeId}&No=${offset}&Nrpp=${productsPerPage}`;
  }
  return !searchParams.get(NAVIGATION_STATE_PARAM_NAME)
    ? `${baseProductsUriPath}?${sprykerBaseQueryParamString}${subcategoryListingProductParms}${filterQueryParams()}&No=${offset}&Nrpp=${productsPerPage}`
    : `${baseProductsUriPath}?${searchParams.get(NAVIGATION_STATE_PARAM_NAME)}&No=${offset}&Nrpp=${productsPerPage}`;
};
export function setNavigationFilterPath(changedFilterUrl, nodeId, isReset = false, seoUrl) {
  const searchParams = new URLSearchParams(window.location.search);
  const queryParamsOfFilterurl = changedFilterUrl.slice(changedFilterUrl.indexOf('?') + 1);
  if (isReset
    && searchParams.has(NAVIGATION_STATE_PARAM_NAME)
    && searchParams.has(SELECTED_NODE_ID)) {
    searchParams.delete(NAVIGATION_STATE_PARAM_NAME);
    searchParams.delete(SELECTED_NODE_ID);
  }
  else {
    searchParams.set(NAVIGATION_STATE_PARAM_NAME, queryParamsOfFilterurl);
    searchParams.set(SELECTED_NODE_ID, nodeId);
  }
  searchParams.delete(OFFSET_PARAM_NAME);
  searchParams.delete(PRODUCTS_PER_PAGE_PARAM_NAME);
  navigationPush(searchParams, seoUrl);
}
export const parseRichText = (richText) => {
  return (richText === null || richText === void 0 ? void 0 : richText.map((text) => text.replace(/<p>|&nbsp;|&#160;|<\/p>/g, '').trim())) || [];
};
export const getSelectedNodeIdFromUrl = (initialNodeId) => {
  const selectedNodeIdFromUrl = getQueryParam(SELECTED_NODE_ID);
  return selectedNodeIdFromUrl !== '' ? selectedNodeIdFromUrl : initialNodeId;
};
export const getPbsFilterProductsUrl = ({ host, ProductsPath, CheckedFiltersUrl, pbsOffset, Nrpp, }) => {
  return `${host}${ProductsPath}?${CheckedFiltersUrl === null || CheckedFiltersUrl === void 0 ? void 0 : CheckedFiltersUrl.split('?')[1]}&No=${pbsOffset}&Nrpp=${Nrpp}`;
};
export const getPbsRangesfiltersUrl = ({ host, rangesPath, CheckedFiltersUrl, }) => {
  return `${host}${rangesPath}?${CheckedFiltersUrl === null || CheckedFiltersUrl === void 0 ? void 0 : CheckedFiltersUrl.split('?')[1]}`;
};
export const getCategoryIdFromName = (categoryName) => {
  const CategoryMatch = categoryName.match(/\d+/);
  return CategoryMatch ? CategoryMatch[0] : '';
};
export const getRangeUrlWithTabHash = (url, tabHash) => {
  if (!tabHash)
    return url;
  return `${url}#${tabHash}`;
};
export const getAnalyticsPageLoadData = () => {
  var _a;
  return (_a = window === null || window === void 0 ? void 0 : window.pesAnalytics) === null || _a === void 0 ? void 0 : _a.pageLoadData;
};
export const getDataForEcommerceAnalyticsEvent = ({ itemListName, isItemListNameAtEcommerceLevel = false, currency = "EUR", items = [], }) => {
  if (isItemListNameAtEcommerceLevel) {
    return {
      ecommerce: {
        item_list_name: itemListName,
        currency,
        items,
      },
    };
  }
  return {
    ecommerce: {
      item_list_name: itemListName,
      currency,
      items,
    },
  };
};
export const getCtaQdsParams = (type, isPrimary = false, isGridView = true) => {
  const [ctaSize, ctaImportance] = (type === PesLinkEnum.button)
    ? [EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD]
    : [EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED];
  return {
    importance: (isPrimary) ? EQdsButtonImportance.EMPHASIZED : ctaImportance,
    size: !isGridView ? EQdsButtonSize.STANDARD : ctaSize,
  };
};
export const getCtaInfoMapping = (productCtas, ctaInfo, isGridView = true) => {
  var _a;
  let type = '';
  let ctaOptions;
  let primary;
  return (_a = productCtas === null || productCtas === void 0 ? void 0 : productCtas.reduce) === null || _a === void 0 ? void 0 : _a.call(productCtas, (result, cta) => {
    var _a, _b, _c, _d;
    type = (_b = (_a = ctaInfo === null || ctaInfo === void 0 ? void 0 : ctaInfo[cta]) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : null;
    primary = (_d = (_c = ctaInfo === null || ctaInfo === void 0 ? void 0 : ctaInfo[cta]) === null || _c === void 0 ? void 0 : _c.primary) !== null && _d !== void 0 ? _d : false;
    ctaOptions = getCtaQdsParams(type, primary, isGridView);
    return Object.assign(Object.assign({}, result), { [cta]: {
        importance: ctaOptions.importance,
        size: ctaOptions.size,
      } });
  }, {});
};
